export class BaseEvent {}
